(async () => {
	const debugMode = 1,
		testId = "GLX-039",
		logInfo = testId + " -->",
		variation = 1;

	try {
		// Avoid code to run multiple times
		if (!document.documentElement.classList.contains(`${testId}_var_${variation}`)) {
			document.documentElement.classList.add(`${testId}_var_${variation}`);
			document.documentElement.classList.add(`${testId}_var`);

			// Tampermonkey has a specific window scope. This will make sure you access the correct website's "window" object.
			let _window = window;
			if (typeof unsafeWindow !== "undefined") _window = unsafeWindow;

			_window._conv_q = _window._conv_q || [];

			// Wait for the main content wrapper
			const waitForElement = (selector) => {
				try {
					return new Promise((resolve) => {
						try {
							if (document.querySelector(selector)) {
								resolve(document.querySelector(selector));
								return;
							}

							const observer = new MutationObserver(() => {
								try {
									if (document.querySelector(selector)) {
										observer.disconnect();
										resolve(document.querySelector(selector));
									}
								} catch (err) {
									if (debugMode) console.error(logInfo, err.message);
								}
							});

							observer.observe(document.documentElement, {
								childList: true,
								subtree: true
							});
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					});
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			// Wait for an element(s) to be fully loaded in the DOM
			const sentConvertEvent = (number, label = "") => {
				try {
					_conv_q.push(["triggerConversion", number]);

					if (debugMode) console.log(logInfo, "Convert event sent:", number, label);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			const sendGAEvent = (category) => {
				try {
					let _category = `hd_${category.toLowerCase().trim().replace(/ /gi, "_")}`;

					_window.dataLayer = _window.dataLayer || [];
					_window.dataLayer.push({
						event: _category
					});

					if (debugMode) console.log(logInfo, "Sent GA event:", _category);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			const trolleySvg = `<svg aria-hidden="true" fill="none" focusable="false" width="24" class="header__nav-icon icon icon-cart" viewBox="0 0 24 24"><path d="M10 7h13l-4 9H7.5L5 3H1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <circle cx="9" cy="20" r="1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle> <circle cx="17" cy="20" r="1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle></svg>`;

			const makeChanges = () => {
				try {
					const quickBuyButtons = document.querySelectorAll(`button[aria-controls^="product-quick-buy"]:not(.${testId}-updated)`);

					quickBuyButtons.forEach((button) => {
						try {
							button.classList.add(`${testId}-updated`);
							button.querySelector("svg").outerHTML = trolleySvg;
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					});
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			waitForElement("body").then(() => {
				try {
					new MutationObserver(makeChanges).observe(document.body, {
						childList: true,
						subtree: true
					});

					makeChanges();
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			});
		}
	} catch (err) {
		if (debugMode) console.error(logInfo, err.message);
	}
})();